import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { Button, Input, Select } from "../../Library/Module";
import { theme } from "../../theme";
import { displayRazorpay } from "../OrderSummery/OrderSummery";
import moment from "moment";
import InputFile from "../../Library/File/File";
import { AddMedicalHistory, CreateMedia, EnquiryDetails } from "../../servies/services";
import { genderOptions } from "./QuickSMSForm";

const LTACSForm = ({
    details
}: { details: any }) => {
    const [formData, setFormData] = useState<any>({});
    const [isFormSubmitted, setIsFormSubmitted]: any = useState(false);
    const [isLoading, setIsLoading]: any = useState(false);
    const [isInValid, setIsInValid]: any = useState(true);
    const onChangeSingleCallback = (data: any) => {
        setFormData((prevState: any) => ({
            ...prevState,
            ...data,
        }));
    };

    const onChangeFileSingleCallback = (data: any) => {
        console.log("data onChangeFileSingleCallback", data)
        setFormData((prevState: any) => ({
            ...prevState,
            ...data,
        }));
    };


    const Submit = async () => {
        setIsLoading(true)
        console.log("formData", formData)
        if (
            formData?.name &&
            formData?.age &&
            formData?.gender &&
            formData?.hospital_currently_admitted &&
            formData?.primary_consutant_name &&
            formData?.mobile &&
            formData?.brief
        ) {
            let fileNamePath: any = []
            if (formData?.medical_report) {
                console.log("formData?.medical_report", formData?.medical_report)
                const formData1 = new FormData();
                const files = Array.from(formData?.medical_report).map((i: any) => {
                    return formData1.append("file", i);
                })
                console.log("files", files)
                formData1.append("email_id", formData?.name);
                formData1.append("type", "ltacs");
                console.log(JSON.stringify(formData1));
                const filePath = await CreateMedia(formData1);
                console.log("CreateMedia", filePath?.data?.data, filePath?.data?.data?.length);
                if (filePath?.data?.data?.length) {
                    filePath?.data?.data?.map((path: any) => {
                        fileNamePath?.push(path?.path)
                    })
                } else {
                    fileNamePath?.push(filePath?.data?.data?.path)
                }
            }
            console.log("fileNamePath", fileNamePath)

            const data = {
                name: formData?.name,
                email_id: formData?.email_id,
                mobile: formData?.mobile,
                comments: formData?.comments ?? '',
                type: formData?.type ?? 'LTACS Form',
                details: {
                    "age": formData?.age,
                    "gender": formData?.gender,
                    "hospital_currently_admitted": formData?.hospital_currently_admitted,
                    "primary_consutant_name": formData?.primary_consutant_name,
                    "brief": formData?.brief,
                    "diagnosis": fileNamePath,
                }
            }
            console.log("APIResponse data", data)
            const APIResponse = await EnquiryDetails(data);
            console.log("APIResponse", APIResponse)

            if (APIResponse?.data?.isSuccess === true) {
                toast.success('Your enquiry has been submitted successfully.');

                setFormData({
                    name: '',
                    email_id: '',
                    mobile: '',
                    comments: ""
                });
                setIsLoading(false);
            } else {
                toast.error("Something went wrong, please try again");
                setIsLoading(false);
            }

        } else {
            toast.error("Please enter required fields");
        }
    }

    useEffect(() => {
        if (
            formData?.name &&
            formData?.age &&
            formData?.gender &&
            formData?.hospital_currently_admitted &&
            formData?.primary_consutant_name &&
            formData?.mobile) {
            setIsInValid(false)
        } else {
            setIsInValid(true)
        }
    }, [formData])

    return (
        <>
            <div className="col-md-4 mb-4">
                <div className="inner">
                    <div className="row">
                        <h3>Form</h3>
                        <Input
                            inputName="name"
                            inputType="text"
                            labelName={"Name of patient"}
                            placeholder="Enter Name of patient"
                            required={true}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.name}
                        />
                        <Input
                            inputName="age"
                            inputType="number"
                            labelName={"Age of patient"}
                            placeholder="Enter Age of patient"
                            required={true}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.age}

                        />


                        <Select
                            inputName={'gender'}
                            labelName={'Gender of patient'}
                            options={genderOptions ?? []}
                            onChangeSingleCallback={onChangeSingleCallback}
                            selectedItem={undefined}
                            required={true}
                            placeholder={'Select Gender'}
                            search_option={false}
                            isLoading={true}
                            value={formData?.gender}
                            col="12"
                        ></Select>

                        <Input
                            inputName="email_id"
                            inputType="text"
                            labelName={"Email Id"}
                            placeholder="Enter Email Id"
                            required={true}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.email_id}
                        />

                        <Input
                            inputName="hospital_currently_admitted"
                            inputType="text"
                            labelName={"Hospital Currently Admitted"}
                            placeholder="Enter Hospital Currently Admitted"
                            required={true}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.hospital_currently_admitted}
                        />
                        <Input
                            inputName="primary_consutant_name"
                            inputType="text"
                            labelName={"Primary Consutant -  Name / Speciality / Contact"}
                            placeholder="Enter Primary Consutant -  Name / Speciality / Contact"
                            required={true}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.primary_consutant_name}
                        />

                        <Input
                            inputName="mobile"
                            inputType="number"
                            labelName={"Contact number of patient / responsible family member to call"}
                            placeholder="Enter Contact number of patient / responsible family member to call"
                            required={true}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.mobile}
                        />

                        <p><strong>Diagnosis</strong></p>

                        <p><strong>upload short summary</strong></p>

                        <InputFile multiple={true} onChangeFileSingleCallback={onChangeFileSingleCallback} inputName="medical_report" />
                        <p><strong>OR</strong></p>
                        <Input
                            inputName="brief"
                            inputType="textarea"
                            labelName={"you can write in brief"}
                            placeholder="You can write in brief"
                            required={false}
                            onChangeSingleCallback={onChangeSingleCallback}
                            col="12"
                            isFormSubmitted={isFormSubmitted}
                            value={formData?.brief}
                        />

                        <div className="col-md-6 text-right"></div>
                        <div className="col-md-6 text-right">
                            <Button
                                onClick={() =>
                                    Submit()
                                }
                                buttonText={"Submit"}
                                buttonStyleType={"primary"}
                                theme={theme}
                                disabled={isLoading || isInValid}
                            >
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LTACSForm